import React, { Fragment, useEffect, useState } from "react";
import './schedule.scss';
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { activateClass, checkOneClass, deleteClass, getClassAndAffiliation, getClassSchedules, getClassStudents, getFaculties, getSchedule, getSubjects, selectAllClasses } from "../../Redux/ActionCreators/scheduleAction";
import { getChapters, getTopics } from "../../Redux/ActionCreators/manageContentAction";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { convertDate, formatTimeTo12Hour } from "../../utils/miscelleneous";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import Switch from "react-switch";
import { TopicLoader } from "../../Loader/loader";
import ViewClass from "./viewClass";
import { Snackbar } from "@mui/material";
import StudentSchedule from "./studentSchedule";

function Schedule() {
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [checked, setChecked] = useState(false);
    const [checkedId, setCheckedId] = useState([]);
    const [isOpenFilter, setIsOpenFilter] = useState(false);
    const [edit, setEdit] = useState(false);
    const [viewSchedule, setViewSchedule] = useState(null);
    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessageText, setSnackMessageText] = useState('');
    const [viewOrEditClass, setViewOrEditClass] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedChapter, setSelectedChapter] = useState(null);
    const [selectedTopic, setSelectedTopic] = useState(null);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [selectedFaculty, setSelectedFaculty] = useState(null);
    const [subjectId, setSubjectId] = useState('');
    const [chapterId, setChapterId] = useState('');
    const [topicId, setTopicId] = useState('');
    const [facultyId, setFacultyId] = useState('');
    const navigate = useNavigate();
    const timerRef = React.useRef(null);

    useEffect(()=> {
        if(localStorage.getItem('role') !== 'student'){
            dispatch(getSchedule(page, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId));
            dispatch(getSubjects());
            setChecked(false);
        }
    }, [])


    const { scheduleList, isListLoading, schedulePagination, faculties, subjectList } = useSelector((state) => state.schedule);
    const { chapterList, topicsList } = useSelector(state => state.manageContent);

    const addClass = () => {
        navigate('/schedule/add-class');
    }

    const notAccess = () => {
        setOpenSnack(true);
        setSnackMessageText('You do not have access to this feature');
    }

    const handleDelete = async () => {
        if (checkedId.length === 0) {
            setOpenSnack(true);
            setSnackMessageText('Please select at least one class');
            return;
        } else if(scheduleList.filter(cls => checkedId.includes(cls._id)).filter(cls => cls.active === true).length > 0) {
            setOpenSnack(true);
            setSnackMessageText('You cannot delete any Active classes. Please deactivate them.');
            return;
        }
        const data = {
            class_ids: checkedId,
        }
        setCheckedId([]);
        setChecked(false);
        await dispatch(deleteClass(data))
        await dispatch(getSchedule(page, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId));
    }

    const handleActivate = async () => {
        if (checkedId.length === 0) {
            setOpenSnack(true);
            setSnackMessageText('Please select at least one class');
            return;
        }
        const data = {
            class_ids: checkedId,
        }
        await dispatch(activateClass(data))
        await dispatch(getSchedule(page, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId));
        setCheckedId([]);
        setChecked(false);
    }

    const searchSchedule = (val) => {
        clearTimeout(timerRef.current);
        setSearch(val);
        timerRef.current = setTimeout(() => dispatch(getSchedule(page, size, val, subjectId, chapterId, topicId, selectedStatus, facultyId)), 800)
    }

    const openFilter = () => {
        setIsOpenFilter(!isOpenFilter)
    }

    const selectTopic = async (selectedOption,) => {
        setSelectedTopic(selectedOption);
        setTopicId(selectedOption.value);
    }

    const selectChapter = async (selectedOption,) => {
        setSelectedChapter(selectedOption);
        setChapterId(selectedOption.value);
        dispatch(getTopics(selectedOption.value));
        setTopicId('')
        setSelectedTopic(null)
    }

    const selectStatus = async (e) => {
        setSelectedStatus(e.target.value);
    }

    const selectSubject = async (selectedOption,) => {
        setSelectedSubject(selectedOption);
        setSubjectId(selectedOption.value);
        await dispatch(getChapters(selectedOption.value));
        const classAffiliation = await dispatch(getClassAndAffiliation(selectedOption.value));
        await dispatch(getFaculties(classAffiliation.payload.affiliation._id, selectedOption.value))
        setFacultyId('')
        setSelectedFaculty(null)
        setTopicId('')
        setSelectedTopic(null)
        setChapterId('')
        setSelectedChapter(null)
    }

    const selectFaculty = async (selectedOption,) => {
        setSelectedFaculty(selectedOption);
        setFacultyId(selectedOption.value);
    }

    const changeSize = (size) => {
        setSize(size);
        dispatch(getSchedule(page, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId));
    }

    const prevPage = () => {
        setPage(page - 1);
        dispatch(getSchedule(page - 1, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId));
    }

    const nextPage = () => {
        setPage(page + 1);
        dispatch(getSchedule(page + 1, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId));
    }

    const handleStatusChange = async (schedule, status) => {
        const data = {
            class_ids: [schedule._id],
            active: status
        }
        await dispatch(activateClass(data))
        await dispatch(getSchedule(page, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId));
        setCheckedId([]);
    }

    const getCheckedId = async (e) => {
        await dispatch(checkOneClass(e.target.value, e.target.checked));
        if (e.target.checked) {
            setCheckedId([...checkedId, e.target.value]);
        }
        else {
            setCheckedId(checkedId.filter(el => el !== e.target.value));
        }
    }

    const checkAll = async (e) => {
        const isChecked = e.target.checked;
        setChecked(isChecked);
        await dispatch(selectAllClasses(isChecked));
        
        if (isChecked) {
            // If checking all, add all schedule IDs to checkedId
            const allIds = scheduleList.map(schedule => schedule._id);
            setCheckedId([...new Set([...checkedId, ...allIds])]);
        } else {
            // If unchecking all, clear the checkedId array
            setCheckedId([]);
        }
    }

    const goToSchedule = () => {
        navigate('/schedule');
        setViewOrEditClass(false);
        setEdit(false);
        // setViewSchedule(null);
    }

    const onFilterClick = (value) => {
        if (value === 'subject') {
            setSelectedSubject(null);
            setSubjectId('');
            setChapterId('');
            setTopicId('');
            dispatch(getSchedule(page, size, search, '', '', '', selectedStatus, facultyId));
        }
        else if (value === 'chapter') {
            setSelectedChapter(null);
            setChapterId('');
            setTopicId('');
            dispatch(getSchedule(page, size, search, subjectId, '', '', selectedStatus, facultyId));
        }
        else if (value === 'topic') {
            setSelectedTopic(null);
            setTopicId('');
            dispatch(getSchedule(page, size, search, subjectId, chapterId, '', selectedStatus, facultyId));
        }
        else if (value === 'faculty') {
            setSelectedFaculty(null);
            setFacultyId('');
            dispatch(getSchedule(page, size, search, subjectId, chapterId, topicId, '', facultyId));
        }
        else if (value === 'status') {
            setSelectedStatus('');
            dispatch(getSchedule(page, size, search, subjectId, chapterId, topicId, selectedStatus, ''));
        }
    }

    const ApplyFilters = () => {
        setIsOpenFilter(false);
        dispatch(getSchedule(page, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId));
    }

    const handleClose = () => {
        setIsOpenFilter(false);
        clearFilters();
    }

    const clearFilters = () => {
        setSelectedStatus('');
        setSelectedSubject(null);
        setSelectedChapter(null);
        setSelectedTopic(null);
        setSelectedFaculty(null);
        setSubjectId('');
        setChapterId('');
        setTopicId('');
        setFacultyId('');
        dispatch(getSchedule(page, size, search, '', '', '', '', '', ''));
    }

    const editClass = (schedule) => {
        setEdit(true);
        setViewSchedule(schedule);
        setViewOrEditClass(true);
    }

    const viewClass = (schedule) => {
        setEdit(false);
        setViewSchedule(schedule);
        setViewOrEditClass(true);
    }

    return (
        localStorage.getItem('role').includes('student') ?
            <StudentSchedule/>
        :
        <Fragment>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={openSnack}
                onClose={() => setOpenSnack(false)}
                message={snackMessageText}
                autoHideDuration={4000}
            />
            {viewOrEditClass ?
            <ViewClass 
                edit={edit}
                setEdit={setEdit}
                schedule={viewSchedule}
                goToSchedule={goToSchedule}
                subjectList={subjectList}
                getSchedule={()=>dispatch(getSchedule(page, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId))}
            />
            :
        <div className='schedule-container'>
            <h3>Class Schedule</h3>
            <div className='schedule-header'>
                <button className='add-button' onClick={(e) => localStorage.getItem('role')=== 'admin' || localStorage.getItem('role') === 'faculty' || localStorage.getItem('role') === 'coordinator' ? addClass() : notAccess()}><img src='/images/plus-white.svg' alt='' />  Add Class</button>
                <div className="has-search"  >
                    <span className="form-control-feedback">
                        <img src="/images/search1.svg" width="14" alt='' />
                    </span>
                    <input type='search' name='student' placeholder='' value={search} id='search' onChange={(e) => searchSchedule(e.target.value)} autoComplete='off' className='form-control' />
                </div>
                <div className='d-flex align-items-center cursor-pointer' onClick={openFilter}>
                    <img src='/images/filter-icon.svg' alt='' /> &nbsp;<p>Filters</p>
                </div>
                <div className='schedule-actions'>
                    <small className='note-line'>Select one or more items before using the below items</small>
                    <div className="d-flex align-items-start justify-content-between" style={{marginTop: '-5px', marginBottom: '10px'}}>
                        <h2 className='cursor-pointer' onClick={handleActivate}>Activate</h2>
                        <h2 className='cursor-pointer' onClick={handleDelete}>Delete</h2>
                    </div>
                </div>
            </div>
            {
            isListLoading ?
                <div>
                    <TopicLoader />
                </div>
                :
                <div className="table-admin" 
                style={{ marginTop: scheduleList?.length === 0 ? -43 : -60 }}
                >
                    <Table responsive style={{ overflow: 'hidden' }}>
                        <thead>
                            <tr className="header-table">
                                <th>
                                    <input type='checkbox' style={{ width: 16, height: 16 }} checked={checked} onChange={(e) => checkAll(e)} />
                                </th>
                                <th style={{ width: '20%' }}>Subject</th>
                                <th style={{ width: '15%' }}>Chapter</th>
                                <th style={{ width: '15%' }}>Class Name</th>
                                <th style={{ width: '12%' }}>Date & Time</th>
                                <th style={{ width: '12%' }}>Faculty</th>
                                <th style={{ width: '6%' }}>Section / Students</th>
                                <th style={{ width: '6%' }}>Present Count</th>
                                <th style={{ width: '6%' }}>Status</th>
                                <th style={{ width: '10%' }}>Action</th>
                            </tr>
                            <hr />
                        </thead>
                        <div className='showing-results' >
                            <p>{selectedSubject !== null || selectedChapter !== null || selectedTopic !== null || selectedFaculty !== null || selectedStatus !== '' ?
                                <span onClick={() => clearFilters('student')}>CLEAR FILTERS</span> : null}</p>
                            {
                                selectedSubject !== null || selectedChapter !== null || selectedTopic !== null || selectedFaculty !== null || selectedStatus !== '' ?
                                    <div className='clear'>
                                        <div className='select-list'>
                                            <ul>
                                                {selectedSubject !== null ? <li >
                                                    {selectedSubject !== undefined && (selectedSubject?.label)}
                                                    <img src="/images/close1.svg" alt='' onClick={() => onFilterClick('subject')} />
                                                </li> : null}
                                                {selectedChapter !== null ? <li >
                                                    {selectedChapter !== undefined && selectedChapter?.label}
                                                    <img src="/images/close1.svg" alt='' onClick={() => onFilterClick('chapter')} />
                                                </li> : null}
                                                {selectedTopic !== null ? <li>
                                                    {selectedTopic !== undefined && selectedTopic?.label}
                                                    <img src="/images/close1.svg" alt='' onClick={() => onFilterClick('topic')} />
                                                </li> : null}
                                                {selectedFaculty !== null ? <li>
                                                    {selectedFaculty !== undefined && selectedFaculty?.label}
                                                    <img src="/images/close1.svg" alt='' onClick={() => onFilterClick('faculty')} />
                                                </li> : null}
                                                {selectedStatus !== '' ? <li>
                                                    {selectedStatus !== undefined && selectedStatus}
                                                    <img src="/images/close1.svg" alt='' onClick={() => onFilterClick('status')} />
                                                </li> : null}
                                            </ul>
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>
                        <tbody className="table-body" >
                            {
                                (scheduleList !== "" && scheduleList !== undefined && scheduleList.length > 0 ?
                                    scheduleList.map((schedule, i) => {
                                        return (
                                            <tr key={i} 
                                            style={{ borderTop: i === 0 ? ( selectedSubject !== null || selectedChapter !== null || selectedTopic !== null || selectedFaculty !== null || selectedStatus !== '') ? '65px solid #F7F7FA' : '15px solid #F7F7FA' : null }}
                                            >
                                                <td>
                                                    <input type='checkbox' onChange={getCheckedId} style={{ width: 16, height: 16 }} value={schedule?._id}
                                                        checked={schedule?.isChecked} />
                                                </td>
                                                <td style={{ width: '20%' }} className='text-center'>{schedule?.subject?.name}</td>
                                                <td style={{ width: '15%' }} className='text-center'>{schedule?.chapter?.name}</td>
                                                <td style={{ width: '15%' }} className='text-center'>{schedule?.title}</td>
                                                <td style={{ width: '12%' }} className='text-center'>
                                                    {convertDate(schedule?.date)}
                                                    <br />
                                                    {formatTimeTo12Hour(schedule?.from)} - {formatTimeTo12Hour(schedule?.to)}
                                                </td>
                                                <td style={{ width: '12%' }} className='text-center'>{schedule.faculty ? schedule.faculty.firstname + ' ' + schedule.faculty.lastname : '-'}</td>
                                                <td style={{ width: '6%' }} className='text-center'>{schedule?.sections?.map(el => el.name).join(', ') || schedule?.students?.length}</td>
                                                <td style={{ width: '6%' }} className='text-center'>{schedule?.attendance || '-'}</td>
                                                <td style={{ width: '6%' }}>
                                                    <div>
                                                    <Switch
                                                        width={30}
                                                        height={16}
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        onColor="#00B24B"
                                                        checked={!!schedule?.active}
                                                        onChange={(checked) => {
                                                            handleStatusChange(schedule, checked)
                                                        }
                                                        }
                                                    />
                                                    <br />
                                                    {schedule?.active ? "Active" : "Inactive"}
                                                    </div>
                                                </td>
                                                <td style={{ width: '8%' }}>
                                                    <img src='/images/view_grey.svg' alt='' width='22px' onClick={() => viewClass(schedule)} />&nbsp;&nbsp;&nbsp;
                                                    <img src='/images/edit.svg' alt='' width='22px' onClick={() => { editClass(schedule) }} />&nbsp;&nbsp;
                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr style={{ borderTop: ( subjectId !== '' || chapterId !== '' || topicId !== '' || facultyId !== '' || selectedStatus !== '') ? '65px solid #F7F7FA' : '35px solid #F7F7FA' }}>
                                        <td colSpan={7}>
                                            <div className='empty-list'>
                                                <img src='/images/empty.png' alt='' />
                                            </div>
                                        </td>
                                    </tr>)
                            }
                        </tbody>
                    </Table>

                </div>
            }
            {
                schedulePagination !== undefined && schedulePagination.totalPages > 1 && 
                <div className='d-flex align-items-center justify-content-between' style={{ marginTop: (scheduleList?.length < 1 ? 315 : 25) }}>
                    <div className='schedule-pagination' 
                        style={{ marginTop: (scheduleList?.length < 1 ? 315 : 25) }}>
                        {
                            page === 1 ?
                                <img src='/images/page_prev_disable.svg' alt='' />
                                : <img src='/images/page_prev_active.svg' onClick={prevPage} alt='' />
                        }
                        &nbsp;&nbsp;
                        <div>Page&nbsp;&nbsp; <input value={page} readOnly />&nbsp;of {schedulePagination?.totalPages}</div>&nbsp;
                        {
                            page === schedulePagination?.totalPages ?
                                <img src='/images/page_next_disable.svg' alt='' /> :
                                <img src='/images/page_next_active.svg' onClick={nextPage} alt='' />
                        }
                    </div>
                    <div className='d-flex align-items-center justify-content-end' style={{ width: schedulePagination !== undefined && schedulePagination.totalPages > 1 ? '20%' : '100%' }}>
                        <select style={{ width: '20%' }} className='form-control' value={size} onChange={(e) => changeSize(e.target.value)}>
                            <option>10</option>
                            <option>20</option>
                            <option>30</option>
                            <option>40</option>
                        </select> &nbsp;
                        <p>Items per page</p>
                    </div>
                </div>
            }

            <Modal show={isOpenFilter} size='lg' centered aria-labelledby="contained-modal-title-vcenter" dialogClassName={"filter-modal"}>
                <Modal.Body style={{ paddingTop: 20, paddingLeft: 70, paddingRight: 70, paddingBottom: 30 }}>
                    <div className="filter">
                        <h1>Filter Classes</h1>
                        <div onClick={handleClose} className='close-upload'><img src='/images/close1.svg' alt='' /></div>
                        <div>
                            <div className='form-group mt-2'>
                                <label>Subject</label>
                                <Select
                                    options={subjectList || []}
                                    value={selectedSubject}
                                    onChange={selectSubject}
                                    getOptionLabel={option => option.label}
                                    getOptionValue={option => option.value}
                                    placeholder="Select subjects..."
                                    className="basic-select"
                                    classNamePrefix="select"
                                />
                            </div>
                            <div className='form-group mt-2'>
                                <label>Chapter</label>
                                <Select
                                    options={chapterList.map(chapter => ({
                                        value: chapter._id,
                                        label: chapter.name
                                    })) || []}
                                    value={selectedChapter}
                                    onChange={selectChapter}
                                    getOptionLabel={option => option.label}
                                    getOptionValue={option => option.value}
                                    placeholder="Select Chapter..."
                                    className="basic-select"
                                    classNamePrefix="select"
                                />
                            </div>
                            <div className='form-group mt-2'>
                                <label>Topic</label>
                                <Select
                                    options={topicsList.map(topic => ({
                                        value: topic._id,
                                        label: topic.name
                                    })) || []}
                                    value={selectedTopic}
                                    onChange={selectTopic}
                                    getOptionLabel={option => option.label}
                                    getOptionValue={option => option.value}
                                    placeholder="Select Topic..."
                                    className="basic-select"
                                    classNamePrefix="select"
                                />
                            </div>
                            <div className='form-group mt-2'>
                                <label>Faculty</label>
                                <Select
                                    options={faculties || []}
                                    value={selectedFaculty}
                                    onChange={selectFaculty}
                                    getOptionLabel={option => option.label}
                                    getOptionValue={option => option.value}
                                    placeholder="Select faculty..."
                                    className="basic-select"
                                    classNamePrefix="select"
                                />
                            </div>
                            <div className='form-group mt-2'>
                                <label>Status</label>
                                <select
                                    value={selectedStatus}
                                    onChange={(e) => selectStatus(e)}
                                >
                                    <option value="">Select Status</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                            <div className='filter-btn '>
                                <div>
                                    <button className='position-relative' onClick={ApplyFilters}>Apply Filters</button>
                                    &nbsp;&nbsp;
                                    <button className='position-relative' onClick={handleClose}>Cancel</button>
                                </div>
                                <p className='position-relative' onClick={clearFilters}>Clear Filters</p>
                            </div>
                        </div>            
                    </div>
                </Modal.Body>
            </Modal>
        </div>}
        </Fragment>
    )
}

export default Schedule;